export const GET_TICKET_LIST = "GET_TICKET_LIST"
export const GET_BLOCK_LIST = "GET_BLOCK_LIST"
export const GET_GENERAL_CONFIG = "GET_GENERAL_CONFIG"
export const UPDATE_GENERAL_CONFIG = "UPDATE_GENERAL_CONFIG"
export const GET_CHECKOUT_CONFIG = "GET_CHECKOUT_CONFIG"
export const UPDATE_CHECKOUT_CONFIG = "UPDATE_CHECKOUT_CONFIG"
export const GET_KEY_STORAGE = "GET_KEY_STORAGE"
export const ADD_KEY_STORAGE = "ADD_KEY_STORAGE"
export const UPDATE_KEY_STORAGE = "UPDATE_KEY_STORAGE"
export const UPDATE_LIST_KEY_STORAGE = "UPDATE_LIST_KEY_STORAGE"
export const UPDATE_TERM_POLICY = "UPDATE_TERM_POLICY"
export const CREATE_TICKET_TEMPLATE = "CREATE_TICKET_TEMPLATE"
export const DELETE_TICKET_TEMPLATE = "DELETE_TICKET_TEMPLATE"
export const UPDATE_TICKET_TEMPLATE = "UPDATE_TICKET_TEMPLATE"
// export const SET_DEFAULT_TICKET_TEMPLATE = "SET_DEFAULT_TICKET_TEMPLATE"
export const MOVE_SUBJECT = "MOVE_SUBJECT"
export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const GET_BUSINESS_WORK_HOUR = "GET_BUSINESS_WORK_HOUR"
export const UPDATE_BUSINESS_WORK_HOUR = "UPDATE_BUSINESS_WORK_HOUR"
export const GET_BOOKING_WORK_HOUR = "GET_BOOKING_WORK_HOUR"
export const GET_SMS_CONTENT = "GET_SMS_CONTENT"
export const UPDATE_SMS_CONTENT = "UPDATE_SMS_CONTENT"
export const GET_POLICIES = "GET_POLICIES"
export const UPDATE_POLICIES = "UPDATE_POLICIES"
export const GET_TAX = "GET_TAX"
export const GET_TIP = "GET_TIP"
export const UPDATE_TAX = "UPDATE_TAX"
export const UPDATE_TIP = "UPDATE_TIP"
export const SET_DEFAULT_TICKET_TEMPLATE = "SET_DEFAULT_TICKET_TEMPLATE"
export const GET_SERVICE_FEE = "GET_SERVICE_FEE"
export const UPDATE_SERVICE_FEE = "UPDATE_SERVICE_FEE"
export const GET_STORE_RATING_DISPLAY = "GET_STORE_RATING_DISPLAY"
export const UPDATE_STORE_RATING_DISPLAY = "UPDATE_STORE_RATING_DISPLAY"
export const RELEASE_QR_CODE = "RELEASE_QR_CODE"

export const GET_COUNTRY_CODE = "GET_COUNTRY_CODE";
export const SET_COUNTRY_CODE = "SET_COUNTRY_CODE";
